module.exports = __webpack_public_path__ + "img/oem1.ce297a7d.png";